import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'assetImageUrl' })
export class AssetImageUrlPipe implements PipeTransform {
    transform(value: string): string {
        let domainAssetUrl = 'assets'
        if(window['environmentVariableConfig']['intelligentadvisorlandingUrl']) {
            domainAssetUrl = this.getHostName(window['environmentVariableConfig']['intelligentadvisorlandingUrl']) + 'assets';
        }
        return `${domainAssetUrl}/${value}`;
    }

    private getHostName(url): string {
         // run against regex
         const matches = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        // extract hostname (will be null if no match is found)
        return matches?.[0];
    }
}